const products = [
  {
    id: 1,
    title: "Product 1",
    description: "Description of product 1",
    price: 120.99,
    image: "/images/Product1.avif",
    category: "RC C/T",
  },
  {
    id: 2,
    title: "Product 2",
    description: "Description of product 2",
    price: 89.99,
    image: "/images/Product2.webp",
    category: "RCB",
  },
  {
    id: 3,
    title: "Product 3",
    description: "Description of product 3",
    price: 49.99,
    image: "/images/Product3.jpg",
    category: "MR",
  },
  {
    id: 4,
    title: "Product4",
    description: "Description of product 4",
    price: 39.99,
    image: "/images/product4.webp",
    category: "Ele",
  },
  {
    id: 5,
    title: "Product5",
    description: "Description of product 5",
    price: 99.99,
    image: "/images/Product5.jpg",
    category: "RCB",
  },
];
export default products;
